import { defineStore } from 'pinia'
import tooManagement from '../api/tooManagement'

export const useSiteSubscriberListStore = defineStore(
  'siteSubscriberListStore',
  {
    state: () => ({
      isLoading: false,
      error: null,
      siteSubscribers: [],
      siteId: '',
      includeArchived: false,
      page: {
        number: 1,
        size: 10,
        totalElements: 0,
        totalPages: 0,
      },
    }),
    actions: {
      async load() {
        // Reset state
        this.siteSubscribers = []
        this.error = null

        this.isLoading = true
        try {
          const siteSubscribers = await tooManagement.getSiteSubscribers({
            siteId: this.siteId,
            includeArchived: this.includeArchived,
            page: this.page.number,
            size: this.page.size,
            sortBy: 'id',
            sortOrder: 'desc',
          })
          // Check if this is the page we requested.
          // Useful if a user requests the next page before the previous page was loaded.
          if (siteSubscribers.meta.page.number === this.page.number) {
            this.siteSubscribers = siteSubscribers.data
            this.page = siteSubscribers.meta.page
          }
        } catch (error) {
          this.error = error
        } finally {
          this.isLoading = false
        }
      },
    },
  },
)
